<app-layout-skeleton>
    <router-outlet/>
</app-layout-skeleton>
